// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"efb8e485","513":"fac17a04"}[chunkId] + ".chunk.js";
};